module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/bg3-760aec3dc5b4da9f2b1de5d54a32062c.jpg";